window.TimePickerDefaultSettings = {
  format: 'hh:mm A',
  time: true,
  shortTime: true,
  date: false,
};

(function () {
  const outingsEventMatchPlaysApp = function () {
    const onDrop = function (el, target) {
      const matchPlayId = $(target).attr('data-match-play-id');
      const newName = `match_plays[${matchPlayId}][]`;
      $(el).find('input').attr('name', newName);
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-bracketed_match_plays'))
        return;

      dragula($('.js-teams-container, .js-match-play-container').toArray(), {
        copy: true,
        accepts: function (el, target, handle) {
          const newId = $(el).find('.team-input').attr('data-id');
          const targetIds = $(target)
            .find('.team-input')
            .toArray()
            .map((elem) => $(elem).attr('data-id'));
          return (
            $(target).find('.team-input').length < 2 &&
            !targetIds.includes(newId)
          );
        },
      }).on('drop', onDrop);

      $(document).on('click', '.remove-team', function (e) {
        window.stopEvent(e);
        $(this).parent().remove();
      });
    });
  };

  if (typeof window !== 'undefined') {
    window.outingsEventMatchPlaysApp = outingsEventMatchPlaysApp();
  }
})();
